import { FunctionComponent, useCallback } from 'react'
import {
  Translation,
  useDxpPreviewParam,
  useIsTablet,
  useWidgetContext,
} from '@dxp-module/common'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { Box, Link, Typography } from '@mui/material'
import returnToMainSiteLinkStyles from './returnToMainSiteLink.styles'

const ReturnToMainSiteLink: FunctionComponent = () => {
  const styles = returnToMainSiteLinkStyles()
  const {
    configuration: { homePageURL },
  } = useWidgetContext()
  const isTablet = useIsTablet()
  const previewSearchParam = useDxpPreviewParam()

  const handleRedirect = useCallback(() => {
    window.location.href =
      `${homePageURL}${previewSearchParam && `?${previewSearchParam}`}` ?? ''
  }, [homePageURL, previewSearchParam])

  if (!isTablet) return null

  return (
    <Link onClick={handleRedirect}>
      <Typography
        variant="subtitle1"
        data-test="myAccount:header:returnToMainSite"
        className={styles.linkText}
      >
        <Box className={styles.container}>
          <ChevronLeftIcon className={styles.linkIcon} />
          <Translation id="trans__myaccount__headers__back_cta" />
        </Box>
      </Typography>
    </Link>
  )
}

export default ReturnToMainSiteLink
